export enum enToggleScanner {
  TOGGLE = 'TOGGLE',
}
